module.exports = __webpack_public_path__ + "static/media/funnel.44a01139.svg";